/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from 'services/auth.service';

export const login = createAsyncThunk('auth/login', async (data, { rejectWithValue }) => {
  try {
    const res = await authService.adminLogin({ username: data.username, password: data.password });
    return res.data;
  } catch (err) {
    // Use `err.response.data` as `action.payload` for a `rejected` action,
    // by explicitly returning it using the `rejectWithValue()` utility
    return rejectWithValue(err.response.data);
  }
});

export const ssoLogin = createAsyncThunk('auth/ssoLogin', async (data, { rejectWithValue }) => {
  try {
    const res = await authService.ssoLogin({ uid: data.uid });
    console.log(res.data);
    return res.data;
  } catch (err) {
    console.log('ssoLogin, reject');
    // Use `err.response.data` as `action.payload` for a `rejected` action,
    // by explicitly returning it using the `rejectWithValue()` utility
    return rejectWithValue(err.response.data);
  }
});

export const userLogin = createAsyncThunk(
  'auth/userLogin',
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const res = await authService.userLogin({ username, password });
      return res.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  },
);

export const googleLogin = createAsyncThunk('auth/login', async (data, { rejectWithValue }) => {
  try {
    const res = await authService.googleLogin({
      ...data,
      //idToken: data.idToken,
    });
    return res.data;
  } catch (err) {
    // Use `err.response.data` as `action.payload` for a `rejected` action,
    // by explicitly returning it using the `rejectWithValue()` utility
    return rejectWithValue(err.response.data);
  }
});

export const logout = createAsyncThunk('auth/logout', async (res) => {
  console.log('logout');
  return res;
});

export const setTokens = createAsyncThunk('auth/setTokens', async (res) => {
  // set tokens om store
  return res;
});

const replaceLocation = (value, location) => {
  let loc = window.location.href;
  const index = loc.indexOf(value);
  loc = index > -1 ? loc.substring(0, index) + location : loc;
  window.location.href = loc;
};

// function deleteAllCookies1() {
//   var cookies = document.cookie.split('; ');
//   for (var c = 0; c < cookies.length; c++) {
//     var d = window.location.hostname.split('.');
//     while (d.length > 0) {
//       var cookieBase =
//         encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
//         '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
//         d.join('.') +
//         ' ;path=';
//       var p = location.pathname.split('/');
//       document.cookie = cookieBase + '/';
//       while (p.length > 0) {
//         document.cookie = cookieBase + p.join('/');
//         p.pop();
//       }
//       d.shift();
//     }
//   }
// }

const STORAGE_KEY = 'auth';

const initialAuthState = {
  accessToken: '',
  refreshToken: '',
  isLoggedIn: false,
  isLoading: false,
  isSsoLoading: false,
  isUserLogin: false,
  authError: '',
  pb_email: '',
  pb_company: '',
  pb_roles: [],
  show_app_name: false,
  pb_number: null,
  publisherList: [],
  rememberMe: null,
  isCaptchaLoaded: false,
  authType: '', //user || admin
  responseError: '',
};
const checkStorages = () => {
  try {
    const localStorage = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    if (localStorage) {
      localStorage.rememberMe = null;
      if (!localStorage.publisherList) {
        localStorage.publisherList = [];
      }
      return localStorage;
    }
  } catch (e) {
    console.log('Error reading from localStorage:', e);
  }
  try {
    const sessionStorage = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
    if (sessionStorage) {
      console.log('Data found in sessionStorage:', sessionStorage);
      sessionStorage.rememberMe = null;
      return sessionStorage;
    }
  } catch (e) {
    console.log('Error reading from sessionStorage:', e);
  }
  console.log('No data found, returning initialAuthState.');
  return structuredClone(initialAuthState);
};

const authSlice = createSlice({
  name: 'auth',
  initialState: checkStorages(),
  reducers: {
    changeAuthType: (state, action) => {
      state.authType = action.payload;
    },
    changeRememberMe: (state, action) => {
      state.rememberMe = action.payload;
    },
    addPublisherToList: (state, action) => {
      const isContained = state?.publisherList?.find(
        ({ pb_number }) => pb_number === action.payload.pb_number,
      );
      if (!isContained) {
        state?.publisherList?.push(action.payload);
      }
      if (state?.publisherList?.length > 15) {
        state?.publisherList?.shift();
      }
    },
    deletePublisherFromList: (state, action) => {
      state.publisherList = state?.publisherList?.filter(
        ({ pb_number }) => pb_number !== action.payload,
      );
    },
    setLoaded: (state, action) => {
      state.isCaptchaLoaded = action.payload;
    },
    setResponseError: (state, action) => {
      state.responseError = action.payload;
    },
    clearAuthState: (state, action) => {
      state.accessToken = '';
      state.refreshToken = '';
      state.pb_email = '';
      state.pb_username = '';
      state.pb_number = null;
      state.isLoggedIn = false;
      state.isUserLogin = false;
      state.pb_roles = [];
      state.show_app_name = false;
    },
    setAuthData: (state, action) => {
      const {
        accessToken,
        refreshToken,
        pb_email,
        pb_username,
        isLoggedIn,
        pb_number,
        pb_roles,
        show_app_name,
        isUserLogin,
        isSamsungUser,
      } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.pb_email = pb_email;
      state.pb_username = pb_username;
      state.isLoggedIn = isLoggedIn;
      state.pb_number = pb_number;
      state.pb_roles = pb_roles;
      state.show_app_name = show_app_name;
      state.authType = 'admin';
      state.isSamsungUser = isSamsungUser;
      if (isUserLogin) {
        state.isUserLogin = isUserLogin;
      }
    },
    setIsSsoLoading: (state, action) => {
      state.isSsoLoading = action.payload;
    },
    setIsLoggedInToTrue: (state, action) => {
      state.isLoggedIn = true;
    },
    setIsLoggedInToFalse: (state, action) => {
      state.isLoggedIn = false;
    },
  },
  extraReducers: {
    [login.pending]: (state) => {
      console.log('login.pending');
      return { ...state, authError: '', isLoading: true };
    },
    [login.fulfilled]: (state, { payload }) => {
      console.log('login.fulfilled');
      return {
        ...state,
        accessToken: payload.access_token,
        refreshToken: payload.refresh_token,
        isLoggedIn: true,
        isLoading: false,
        pb_email: payload.pb_email,
        pb_username: payload.pb_username,
        pb_roles: payload.pb_roles,
        show_app_name: payload.show_app_name,
      };
    },
    [login.rejected]: (state, action) => {
      console.log('login.rejected', action);
      return { ...state, authError: action.error.message, isLoading: false };
    },
    [ssoLogin.pending]: (state) => {
      console.log('ssoLogin.pending');
      return { ...state, authError: '', isLoading: true, isSsoLoading: true };
    },
    [ssoLogin.fulfilled]: (state, { payload }) => {
      console.log('ssoLogin.fulfilled');
      return {
        ...state,
        accessToken: payload.access_token,
        refreshToken: payload.refresh_token,
        isLoggedIn: true,
        isLoading: false,
        isSsoLoading: false,
        pb_email: payload.pb_email,
        pb_username: payload.pb_username,
        pb_roles: payload.pb_roles,
        show_app_name: payload.show_app_name,
      };
    },
    [ssoLogin.rejected]: (state, { payload }) => {
      console.log('ssoLogin.rejected');
      replaceLocation('v2/', 'dashboard.aspx');
      return { ...state, authError: payload.Message, isLoading: false, isSsoLoading: false };
    },
    [userLogin.pending]: (state) => {
      console.log('userLogin.pending');
      return { ...state, authError: '', isLoading: true };
    },
    [userLogin.fulfilled]: (state, { payload }) => {
      console.log('userLogin.fulfilled');
      return {
        ...state,
        accessToken: payload.access_token,
        refreshToken: payload.refresh_token,
        show_app_name: payload.show_app_name,
        isLoggedIn: true,
        isLoading: false,
      };
    },
    [userLogin.rejected]: (state, { payload }) => {
      console.log('userLogin.rejected');
      return { ...state, authError: payload.Message, isLoading: false };
    },
    [logout.pending]: () => {
      console.log('logout.pending');
      //console.log('Pending');
    },
    [logout.fulfilled]: (state) => {
      console.log('logout.fulfilled');
      return {
        ...state,
        accessToken: '',
        refreshToken: '',
        isLoggedIn: false,
        show_app_name: false,
      };
    },
    [setTokens.fulfilled]: (state, { payload }) => {
      console.log('setTokens.fulfilled');
      return {
        ...state,
        accessToken: payload.access_token,
        refreshToken: payload.refresh_token,
        isLoggedIn: true,
      };
    },
  },
});

export const authActions = authSlice.actions;
authActions.STORAGE_KEY = STORAGE_KEY;
export default authSlice.reducer;
